import { Box, Heading, SimpleGrid, Divider } from '@hover/blueprint';
import React from 'react';
import { CAREERS_OUR_VALUES } from '../../../constants';

interface Props {
  selectTab: (title: string) => void;
  description: string;
  currentTab: string;
}

const OurValuesDesktop: React.FC<Props> = ({
  selectTab,
  description,
  currentTab,
}) => (
  <SimpleGrid
    d={{ base: 'none', tablet: 'grid' }}
    w="100%"
    columns={3}
    spacing={{ tablet: 700, desktop: 0 }}
  >
    <Heading
      mx="auto"
      ml={{ desktop: 800 }}
      size={{ tablet: 600, desktop: 700 }}
      isLight
      maxW="150px"
    >
      Our values
    </Heading>
    <Box flexDir="column" maxW={{ tablet: '240px', desktop: '273px' }}>
      {CAREERS_OUR_VALUES.map(value => (
        <Box key={value.id} flexDir="column">
          <Divider
            my={0}
            borderColor="brandNavy.300"
            borderWidth="1px"
            borderTopWidth={0}
          />
          <Heading
            onClick={() => selectTab(value.title)}
            marginBottom={{ tablet: 500, desktop: 500 }}
            marginTop={{ tablet: 600, desktop: 600 }}
            size={{ tablet: 600, desktop: 700 }}
            cursor="pointer"
            color={currentTab === value.title ? 'brandNavy.500' : 'neutral.0'}
            transition="all 0.2s linear"
          >
            {value.title}
          </Heading>
        </Box>
      ))}
      <Divider
        my={0}
        borderColor="brandNavy.300"
        borderWidth="1px"
        borderTopWidth={0}
      />
    </Box>
    <Heading
      maxW={{ tablet: 'auto', desktop: '360px' }}
      size={400}
      isDisplay
      mt={{ tablet: 400, desktop: 600 }}
    >
      {description}
    </Heading>
  </SimpleGrid>
);

export default OurValuesDesktop;
